<div class="cm-skeleton-profile">
  <!-- Card 1: Profile Information -->
  <div class="cm-skeleton-profile-card">
    <!-- Card header (title + subtitle) -->
    <div class="cm-skeleton-profile-header">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 220px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 300px; margin-top: 0.5rem;"></div>
    </div>

    <!-- Profile image uploader (avatar + upload button) -->
    <div class="cm-skeleton-profile-uploader">
      <div class="cm-skeleton cm-skeleton--circle cm-skeleton--{{ animation() }}" style="width: 72px; height: 72px;"></div>
      <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 150px; height: 40px; border-radius: 4px;"></div>
    </div>

    <!-- Informational notice -->
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 64px; border-radius: 4px;"></div>

    <!-- Field rows: 2 + 2 + 1 + 2 -->
    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>

    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>

    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>

    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>
  </div>

  <!-- Card 2: Role & Teams -->
  <div class="cm-skeleton-profile-card">
    <!-- Card header (title + subtitle) -->
    <div class="cm-skeleton-profile-header">
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--lg cm-skeleton--{{ animation() }}" style="width: 180px;"></div>
      <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 340px; margin-top: 0.5rem;"></div>
    </div>

    <!-- Informational notice -->
    <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 64px; border-radius: 4px;"></div>

    <!-- Field rows: 2 + 1 -->
    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>

    <div class="cm-skeleton-profile-grid">
      <div class="cm-skeleton-profile-field">
        <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 100px; margin-bottom: 0.5rem;"></div>
        <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
      </div>
    </div>
  </div>
</div>
